import type { Follow } from '../../types/following.ts';

export type PredictionState = {
  predictions: Follow[];
  includeGoalChasing: boolean;
};

export type PredictionStateAction =
  | { type: 'setPredictions'; payload?: Follow[] }
  | { type: 'setIncludeGoalChasing'; payload: boolean }
  | { type: 'reset'; payload: undefined };

const predictionReducer = (
  state: PredictionState,
  action: PredictionStateAction
): PredictionState => {
  const { type, payload } = action;
  switch (type) {
    case 'setPredictions':
      return {
        ...state,
        predictions: payload ?? [],
      };

    case 'setIncludeGoalChasing':
      return {
        ...state,
        includeGoalChasing: payload,
      };

    case 'reset':
      return {
        ...state,
        predictions: [],
      };

    default:
      return state;
  }
};

export default predictionReducer;
